module.exports = __webpack_public_path__ + "static/img/2.bd2bf49.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/3/eng/2.png
// module id = YzAW
// module chunks = 0